import { all, fork } from "redux-saga/effects";
import { loginSaga } from "../db/saga/login";
import { watchVerifyOtp, watchResendOtp } from "../db/saga/otpValidation";
import { registerSaga } from "../db/saga/register";
import { loginAnotherWaySaga } from "../db/saga/loginAnotherWay";
import { forgotPasswordSaga } from "../db/saga/forgotPassword";
import { resetPasswordSaga } from "../db/saga/resetPassword";
import { resetPasswordRequestSaga } from "../db/saga/resetPasswordRequest";
import { userSetupSaga } from "../db/saga/userSetup";
import { accountSetupSaga } from "../db/saga/accountSetup";

export default function* rootSaga() {
  yield all([
    fork(loginSaga),
    fork(watchVerifyOtp),
    fork(registerSaga),
    fork(loginAnotherWaySaga),
    fork(forgotPasswordSaga),
    fork(resetPasswordSaga),
    fork(resetPasswordRequestSaga),
    fork(watchResendOtp),
    fork(userSetupSaga),
    fork(accountSetupSaga),
  ]);
}
